import Config from '@/config'
import { WebView } from 'react-native-webview'

export default function JoinWallyModal() {
	return (
		<WebView
			style={{
				backgroundColor: '#f8eddf',
			}}
			source={{
				uri: `${Config.JOIN_URL}?utm_source=patient_app`,
			}}
			bounces={false}
		/>
	)
}
